import { supabase } from "@/lib/supabase";

export const WORKPLACE_CHAT_VENDOR_CONFIG_ACTION =
  "/api/admin/action?action=workplace-chat-vendor-config";

export type WorkplaceChatVendorConfigStatus = {
  ok: true;
  organization_id: string;
  vendor_enabled: boolean;
  vendor: string | null;
  org_channels: string[];
  stream_credentials_configured: boolean;
  effectively_enabled: boolean;
};

async function authHeaders(): Promise<Record<string, string> | null> {
  if (!supabase) return null;
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return null;
  return { Authorization: `Bearer ${token}` };
}

export async function fetchWorkplaceChatVendorConfig(
  organizationId: string
): Promise<WorkplaceChatVendorConfigStatus | { ok: false; error: string }> {
  const headers = await authHeaders();
  if (!headers) return { ok: false, error: "Sign in required." };
  try {
    const q = new URLSearchParams({ organization_id: organizationId });
    const r = await fetch(`${WORKPLACE_CHAT_VENDOR_CONFIG_ACTION}&${q.toString()}`, {
      method: "GET",
      headers,
    });
    const json = (await r.json()) as WorkplaceChatVendorConfigStatus & {
      ok?: boolean;
      error?: string;
    };
    if (!r.ok || json.ok !== true) {
      return { ok: false, error: json.error || `HTTP ${r.status}` };
    }
    return json;
  } catch (e: unknown) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}

export async function patchWorkplaceChatVendorConfig(input: {
  organizationId: string;
  vendorEnabled: boolean;
}): Promise<WorkplaceChatVendorConfigStatus | { ok: false; error: string }> {
  const headers = await authHeaders();
  if (!headers) return { ok: false, error: "Sign in required." };
  try {
    const r = await fetch(WORKPLACE_CHAT_VENDOR_CONFIG_ACTION, {
      method: "PATCH",
      headers: { ...headers, "Content-Type": "application/json" },
      body: JSON.stringify({
        organization_id: input.organizationId,
        vendor_enabled: input.vendorEnabled,
      }),
    });
    const json = (await r.json()) as WorkplaceChatVendorConfigStatus & {
      ok?: boolean;
      error?: string;
    };
    if (!r.ok || json.ok !== true) {
      return { ok: false, error: json.error || `HTTP ${r.status}` };
    }
    return json;
  } catch (e: unknown) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}
